<script setup>
  const props = defineProps({
    video: {
      type: Array,
      default: null,
    },
    youtubeId: {
      type: String,
      default: null,
    },
    thumbnail: {
      type: Object,
      required: true,
    },
    download: {
      type: Boolean,
      default: false,
    },
  })

  const isYoutube = computed(() => !!props.youtubeId)
  const src = computed(() =>
    props.youtubeId
      ? `//youtube.com/watch?v=${props.youtubeId}`
      : props.video[0].videoPreviewURLs[0]
  )
  const downloadFileType = computed(
    () => props.video[0]?.type
  )

</script>

<template>
  <section class="module-video">
    <VideoPlayer inline :youtube="isYoutube" :src="src" :poster="thumbnail?.url" />
    <div class="video-button"  v-if="download && video.length > 0">
      <ButtonPill animate icon="download" download :href="video[0].videoPreviewURLs[0]"
        target="_blank" rel='noopener noreferrer'>
        Download {{ downloadFileType }}
      </ButtonPill>
    </div>
  </section>

</template>

<style lang="scss">
  @import '~/styles/vendors/sass-mq/mq';
  @import '~/styles/utils/functions';

  .module-video {
    margin: 0 auto;
    width: 100%;

    @include mq($from: 'm') using ($from) {
      max-width: gs(5, 4, 'xxxs');
    }

    @include mq($from: 'l') using ($from) {
      max-width: gs(18, 17, 'l');
    }
  }
  .video-button{
    text-align: center; 
    margin-top: 40px
  }
</style>